export default {
    nav: {
        home: "головна",
        gallery: "галерея",
        updates: "зміни",
        help: "допомога",
        operation: "експлуатація",
        contacts: "контакти",
    },
    layout: {
        brand_subtitle: "library software platform",
        cta: "зв’язатися",
        switch_language: "мова",
        image_viewer: {
            title: "Зображення",
        },
        button: {
            close: "Закрити",
        },
    },
    footer: {
        description: "Професійна бібліотечна система для автоматизації основних процесів сучасної бібліотеки.",
        rights: "усі права українському народу",
    },
    home: {
        capabilities_title: "ключові можливості",
        capabilities_text: "Платформа покриває основні бібліотечні процеси та дає установі зрозумілий цифровий контур для щоденної роботи.",
        audience_title: "для яких бібліотек підходить",
        cta_updates: "переглянути зміни",
    },
    gallery: {
        title: "галерея",
        text: "Ласкаво просимо до галереї UniLib. Тут зібрано візуальні матеріали та приклади інтерфейсів системи.",
    },
    updates: {
        title: "останні зміни",
        text: "Ознайомтесь з останніми оновленнями UniLib. Це лише частина змін, що демонструє активний розвиток і живість системи.",
    },
    help: {
        title: "довідка",
        text: "Розділ довідки перебудований як каталог матеріалів із окремими сторінками статей.",
        open_article: "відкрити статтю",
        back: "до розділу довідки",
    },
    operation: {
        title: "експлуатація",
        text: "Тут зібрано короткий опис сценарію впровадження, оновлення та підтримки системи.",
    },
    contacts: {
        title: "контакти",
        text:
            "Звертайтеся до нас з будь-яких питань, пов’язаних із системою UniLib. " +
            "Ми надамо необхідну інформацію, проконсультуємо щодо можливостей системи та варіантів її впровадження у вашій інфраструктурі. " +
            "Розглядаємо як стандартні сценарії використання, так і задачі з підвищеними вимогами та особливостями реалізації.",
    },
    legacy: {
        title: "Сайт оновлено",
        text: "Ви перейшли за застарілою адресою. Структуру сайту було оновлено. Будь ласка, розпочніть роботу з головної сторінки або зв’яжіться з нами для уточнення інформації.",
        home: "На головну",
        contact: "Зв'язатися",
    },
} as const;
